<dialog-draggable-header>{{data.allParts ? 'All Parts' : 'Parts By Program' }}</dialog-draggable-header>

<data-table #partsByProgramTable [data]="parts" [columns]="partProgramcolumns" [loading]="loading" [paging]="true"
  [pageSize]="pageOptions.size" [totalRecords]="totalParts" [lazy]="true" (lazyLoad)="onLazyLoad($event)"
  [multiselect]="true" [defaultSortField]="'partNumber'" [filterColumnDisplay]="false">
  <ng-container actionStart>
    <span class="ml-2">{{data.allParts ? '' : ' Program: ' + data.tool.programNameYear}}</span>
    <mat-form-field class="ml-3">
      <mat-label>Search Part Number</mat-label>
      <input #searchBar id="search-part-id" type="text" matInput (keydown.enter)="searchPartChange(searchBar)"
        [(ngModel)]="searchBarInput" />
      <span *ngIf="searchBarInput" style="margin-left:-20px;">
        <a (click)="clearSearch()">
          <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
        </a>
      </span>
      <button mat-icon-button matSuffix (click)="searchPartChange(searchBar)"
        (keydown.enter)="searchPartChange(searchBar)">
        <mat-icon matSuffix>search</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>
  <ng-container actionEnd>
    <button class="p-0 mx-2" mat-button (keypress)="saveParts()" (click)="saveParts()">Save</button>
    <mat-divider vertical class="ml-0 action-bar-vertical-divider"></mat-divider>
    <button mat-dialog-close mat-button> Cancel </button>
  </ng-container>
</data-table>
